import { useMemo, useRef } from 'react';

import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { setAddFileAction } from 'components/app/editor/_mediator/editor-actions.slice';
import { usePickerContext } from './picker.provider';

import { ReactComponent as FolderIcon } from 'assets/folder.svg';
import { ReactComponent as GooglePhotosIcon } from 'assets/social/google-photos.svg';
import { HoverBtn } from 'components/app/app-components/hover-btn/hover-btn';
import styles from './_picker.module.scss';

export const PickerBase = ({ children }: React.HTMLAttributes<HTMLDivElement>) => {
  const addFileAction = useAppSelector((state) => state.editor__actions.addFileAction);
  const extensions = useAppSelector((state) => state.app__data.extensions);
  const inputRef = useRef<HTMLInputElement>(null);
  const dispatch = useAppDispatch();

  const { onPick, gpInit } = usePickerContext();

  const accept = useMemo(() => {
    return extensions ? [...extensions.audio, ...extensions.video, ...extensions.image].join() : '';
  }, [extensions]);

  const onFilesSubmit = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.currentTarget.files!);
    onPick(files);
  };

  const onGoogle = () => {
    dispatch(setAddFileAction('google'));
    gpInit();
  };

  const onLocal = () => {
    dispatch(setAddFileAction('local'));
    inputRef.current?.click();
  };

  const onAction = () => {
    switch (addFileAction) {
      case 'google':
        onGoogle();
        break;
      case 'local':
        onLocal();
        break;
    }
  };

  return (
    <HoverBtn
      className={styles.PickerBase}
      button={<div onClick={() => onAction()}>{children}</div>}
      positionRight={true}
      dots={false}
    >
      <ul>
        <li className={styles.PickerBase__local} onClick={onLocal}>
          <span>
            <FolderIcon />
          </span>
          Local
        </li>
        <li onClick={onGoogle}>
          <span>
            <GooglePhotosIcon />
          </span>
          Photos
        </li>
      </ul>
      <input
        ref={inputRef}
        onChange={onFilesSubmit}
        onClick={(event) => ((event.target as HTMLInputElement).value = '')}
        style={{ display: 'none' }}
        accept={accept}
        type="file"
        multiple
      />
    </HoverBtn>
  );
};
